<template>
  <div>
    <Modal
      class="editBlock clas"
      v-model="modal"
      :title=" newclasstatus ? '新增分类':'编辑分类'"
      width="25"
      footer-hide
      :styles="{top: '20%'}"
    >
      <div class="bodyhigh">
        <div class="bodyfirst">
          <div class="title">分类基本信息</div>
          <div class="content">
            <Row>
              <Col span="24" class="necessary">
                <div>
                  <label>
                    <span>*</span>分类名称
                  </label>
                  <Input v-model="clasname" class="editInput comapny-name" type="text"></Input>
                  <p v-if="exit">名稱重複</p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div v-if="newclasstatus" class="btn" @click="addConfirm">提交</div>
          <div v-else class="btn" @click="editClasSubmit">儲存</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "ModalClas",
  props: {
    classtatus: {
      type: Boolean,
      required: true
    },
    clas: {
      type: Array,
      required: true
    },
    newclasstatus: Boolean,
    clasItem: Object,
  },
  data () {
    return {
      clasname: '',
      exit: false,
      tempoclasItem: {}
    }
  },
  computed: {
    modal: {
      get () {
        return this.classtatus
      },
      set (val) {
        this.clasname = ''
        this.$emit("update:classtatus", val)
        this.$emit("update:clasItem", '')
        this.$emit("update:newclasstatus", false)
        this.$emit("update:editclasstatus", false)
      }
    }
  },
  watch: {
    clasItem () {
      this.tempoclasItem = JSON.parse(JSON.stringify(this.clasItem))
      this.clasname = this.tempoclasItem.gupname
    }
  },
  methods: {
    //提交确定
    addConfirm () {
      this.exit = false;
      this.clas.forEach(i => {
        if (i.gupname === this.clasname.trim()) this.exit = true;
      });
      if (this.exit) return;
      this.$axios
        .insqskgup({ gupname: this.clasname.trim() })
        .then(res => {
          this.clasname = "";
          this.$emit("getclas")
        })
        .catch(err => console.error(err))
      this.modal = false
    },

    //編輯分類確認送出
    editClasSubmit () {
      let obj = {
        gupid: this.clasItem.gupid,
        gupname: this.clasname
      };
      this.$axios
        .updqskgup(obj)
        .then(res => {
          this.$emit("getclas")
          this.$emit("getQkmsg")
        })
        .catch(err => console.error(err))
      this.modal = false
    },
    reset () {
      this.clasname = ''
    }
  }
}
</script>
<style lang="less">
.editBlock.clas {
  .ivu-input {
    width: 70%;
  }
  p {
    color: var(--main-red);
    margin-left: 80px;
    margin-top: -5px;
    font-size: 6px;
  }
}
</style>